import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["status", "details"]
  static values = {
    animationDuration: { type: Number, default: 300 }
  }

  connect() {
    this.toggleDetails()
  }

  toggleDetails() {
    const selectedStatus = this.getSelectedStatus()
    const shouldShow = selectedStatus === "attending" || selectedStatus === "maybe"
    
    if (shouldShow) {
      this.showDetails()
    } else {
      this.hideDetails()
    }
  }

  getSelectedStatus() {
    const checkedRadio = this.statusTargets.find(radio => radio.checked)
    return checkedRadio ? checkedRadio.value : null
  }

  showDetails() {
    if (!this.hasDetailsTarget) return
    
    const details = this.detailsTarget
    details.classList.remove("hidden")
    details.setAttribute("aria-hidden", "false")
    
    details.style.opacity = "0"
    details.style.transform = "translateY(-10px)"
    details.offsetHeight
    details.style.transition = `opacity ${this.animationDurationValue}ms ease, transform ${this.animationDurationValue}ms ease`
    details.style.opacity = "1"
    details.style.transform = "translateY(0)"
  }

  hideDetails() {
    if (!this.hasDetailsTarget) return
    
    const details = this.detailsTarget
    
    details.style.transition = `opacity ${this.animationDurationValue}ms ease, transform ${this.animationDurationValue}ms ease`
    details.style.opacity = "0"
    details.style.transform = "translateY(-10px)"
    
    setTimeout(() => {
      details.classList.add("hidden")
      details.setAttribute("aria-hidden", "true")
      details.style.opacity = ""
      details.style.transform = ""
      details.style.transition = ""
    }, this.animationDurationValue)
  }
}
